import type { CoverSheetConfigCard } from '../../types';

export const listingPriceCard = {
  id: 'propertyInfo.listingPrice',
  innerTitle: 'Listing Price',
  layout: [[{ name: 'listingPrice', size: 100 }]],
  fields: {
    listingPrice: {
      name: 'listingPrice',
      entity: 'interaction',
      type: 'money',
      label: 'Current Listing Price',
      action: {
        name: 'priceHistory',
        dialog: [
          {
            type: 'approve',
            title: 'Are you sure you want to delete this price history entry?',
            content:
              'Once you delete a listing price from your history, it will be disabled. You can restore it later. Please note that deleting the latest price in your history will change your current listing price.',
            actions: [
              {
                type: 'deny',
                label: 'CANCEL',
                ariaLabel: 'Do not delete',
              },
              {
                type: 'accept',
                label: 'DELETE',
                ariaLabel: 'Delete listing price',
              },
            ],
          },
          {
            type: 'deny',
            title: 'Are you sure you want to restore a price history entry?',
            content:
              'Once you restore a deleted listing price, it will be activated in your price history. Please note that restoring a deleted price might change your current listing price.',
            actions: [
              {
                type: 'deny',
                label: 'CANCEL',
                ariaLabel: 'Do not delete',
              },
              {
                type: 'accept',
                label: 'RESTORE',
                ariaLabel: 'RESTORE listing price',
              },
            ],
          },
        ],
      },
      placeholderText: '0.00',
      validation: [
        {
          type: 'required',
          message: 'Required',
        },
      ],
    },
  },
} satisfies CoverSheetConfigCard;
